<nz-table [nzData]="rows" [nzFrontPagination]="false" [nzBordered]="true" [nzSize]="'small'">
  <thead>
    <tr>
      <th>OFF LOADING ITEM</th>
      <th *ngFor="let po of poNumbers; let i = index">
        {{ getPoLabel(i, po) }}
      </th>
      <th>OVERLOADING</th>
    </tr>
  </thead>

  <tbody>
    <tr *ngFor="let row of rows">
      <td>{{ row.offloadItem }}</td>

      <td *ngFor="let po of poNumbers">
        <nz-select style="width: 100%;" nzAllowClear nzPlaceHolder="Select item" [(ngModel)]="row.poSelections[po]"
          [nzDisabled]="isPoDisabled(row, po)" (ngModelChange)="onPoSelectionChange(row, po)">
          <nz-option *ngFor="let item of row.poOptions[po]" [nzValue]="item" [nzLabel]="item">
          </nz-option>
        </nz-select>
      </td>

      <td>
        <nz-select style="width: 100%;" nzAllowClear nzPlaceHolder="Select PO" [(ngModel)]="row.overloadPo"
          [nzDisabled]="isOverloadDisabled(row)" (ngModelChange)="onOverloadChange(row)">
          <nz-option *ngFor="let po of row.overloadOptions" [nzValue]="po" [nzLabel]="po">
          </nz-option>
        </nz-select>
      </td>
    </tr>
  </tbody>
</nz-table>

<div *ngIf="errorMessage" style="margin-top: 16px;">
  <nz-alert nzType="error" [nzMessage]="errorMessage" nzShowIcon>
  </nz-alert>
</div>

<div style="margin-top: 16px; text-align: right;">
  <button nz-button nzType="primary" [disabled]="submitting" (click)="submit()">
    Submit
  </button>
</div>
